import DotsLoader from './DotsLoader';

export default DotsLoader;
